import { MouseEvent, PropsWithChildren, ReactElement, useRef } from "react";
import { className } from "../../../../shared/helpers";
import { SortedField } from "../../../../shared/sort";
import { SortUpdate, TableState } from "../../table-data";
import SortableColumn from "./SortableColumn";
import styles from "./TableWrapper.module.scss";

export interface TableColumn
{
    label: string;
    sticky?: boolean;
    sortable?: boolean;
    visible?: boolean;
    group?: TableColumn[];
}

interface TableWrapperProps
{
    tableLoadingState: boolean;
    columns: TableColumn[];
    collapsed: boolean;
    sortedField?: SortedField;
    setSortData?: (sortData: SortUpdate) => void;
    setTableLoadingState: (setLoading: boolean) => void;
    tableState: TableState;
}

const TableWrapper = (props: PropsWithChildren<TableWrapperProps>): ReactElement =>
{
    const rowRef = useRef<HTMLTableRowElement>(null as any);

    const setSortData = (sortedField: SortedField): void =>
    {
        if (!sortedField || !props.setSortData) return;
        props.setTableLoadingState(true);
        props.tableState.data.clearRows();
        props.tableState.filters.pageNumber = 1;
        props.setSortData({
            sortBy: sortedField.caption,
            sortOrder: sortedField.order
        });
    }

    const preventDoubleClick = (e: MouseEvent): void =>
    {
        if (props.tableLoadingState)
            return;
    }

    const setHeaderColumn = (column: TableColumn, i: number): ReactElement =>
    {
        return (
            <th
                key={i}
                style={{ pointerEvents: props.tableLoadingState ? "none" : "all" }}
                onClick={preventDoubleClick}
            >
                {column.sortable && (
                    <SortableColumn
                        field={column.label}
                        sortedField={props.sortedField!}
                        setSortedField={(sortedField: SortedField) => setSortData(sortedField)}
                        tableLoadingState={props.tableLoadingState}
                    />
                )}

                {!column.sortable && column.label}
            </th>
        );
    }

    return (
        <table {...className(styles.table, { [styles.collapsed]: props.collapsed })}>
            <thead className={styles.tableHeader}>
                <tr className={styles.groupLabelsRow}>
                    {props.columns.map((column: TableColumn, i: number) =>
                    {
                        if (column.visible !== undefined && !column.visible) return null as any;

                        return !column.group
                            ? <th key={i} className={styles.empty} />
                            : <th key={i} colSpan={column.group.length}><span>{column.label}</span></th>
                    })}
                </tr>

                <tr ref={rowRef}>
                    {props.columns.map((column: TableColumn, i: number) =>
                    {
                        if (column.visible !== undefined && !column.visible) return null as any;

                        return !column.group
                            ? setHeaderColumn(column, i)
                            : column.group.map((grouppedColumn, i) => setHeaderColumn(grouppedColumn, i))
                    })}
                </tr>
            </thead>

            <tbody>{props.children}</tbody>
        </table>
    );
}

export default TableWrapper;
